import { render } from "./Statoperates.vue?vue&type=template&id=4a63761c&scoped=true"
import script from "./Statoperates.vue?vue&type=script&lang=js"
export * from "./Statoperates.vue?vue&type=script&lang=js"

import "./Statoperates.vue?vue&type=style&index=0&id=4a63761c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a63761c"]])

export default __exports__